import axios from "axios";
import config from "../../../config";

export async function fetchExternalStatus() {
    try {
        const googleApiKey = config.SYSTEM_STATUS_GOOGLE_PUBLIC_API_KEY;
        const spreadsheetId = config.SYSTEM_STATUS_GOOGLE_SPREADSHEET_ID;
        const range = "banner!A1:E100";

        const url = `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values/${encodeURIComponent(range)}?key=${googleApiKey}`;

        const response = await axios.get(url, { headers: { "Cache-Control": "no-cache" } });
        const values = response.data.values; // [ [header1, header2, ...], [row1...], ... ]

        if (!values || values.length < 2) return [];

        const headers = values[0];
        const rows = values.slice(1);

        const records = rows
            .filter((row) => row[0] === "TRUE")
            .map((row) => {
                const obj = {};
                headers.forEach((h, i) => {
                    obj[String(h).trim()] = row[i] || "";
                });
                return obj;
            });

        return records;
    } catch (e) {
        console.error("Failed to fetch sheet via API", e);
        return [];
    }
}
